import { loadStripe } from '@stripe/stripe-js';

// Publishable keys are public. Override for test mode; retain the existing live default.
const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
    || 'pk_live_51PexFn2LxS9rV2S4jEp30qRFF8DK5Crr6KxDD3NsnEgLrl12PZQ7hCENsCKyLf7O6TIuSMfNbnjfVHeGk0Osh2EW00Rf4hdjgi';

export const stripePromise = loadStripe(publishableKey);
